export enum DeviceColumns {
  Hardware = "hardware",
  IMEI = "imei",
  FirmwareVersion = "firmwareVersion",
  Customer = "customer",
  AssignedVehicle = "name",
  VehicleGroups = "groups",
  VehicleTemplate = "vehicleTemplate",
  VehicleModel = "vehicleModel",
  VehicleBrand = "vehicleBrand",
  VehicleType = "vehicleType",
  Template = "template",
  TachoSupport = "tacho",
  SMSResponse = "smsResponse",
  SMSResponseDatetime = "smsResponseDatetime",
  DeviceState = "configState",
  FSMState = "stateMachineState",
  FWUploadStatus = "firmwareUploadStatus",
  FWDatetime = "firmwareDateTime",
  FWVersion = "firmwareVersion",
  ConfigName = "configName",
  DownloadConfig = "downloadConfig",
  ConfigUploadStatus = "configUploadStatus",
  Vin = "vin",
  IsLSVA = "isLSVA",
  ConfigDateTime = "configDateTime",
  CurrentDataDatetime = "currentDataDatetime",
  CurrentData = "currentData",
  SIMType = "simType",
  SIMGPRSLastConnectionStart = "simGPRSLastConnectionStart",
  SIMGPRSLastConnectionStop = "simGPRSLastConnectionStop",
  SIMMsisdn = "simMsisdn",
  SIMLifeCycleStatus = "simLifeCycleStatus",
  SIMCommercialGroup = "simCommercialGroup",
  SIMConsumptionMonthlyData = "simConsumptionMonthlyData",
  BillingTariff = "billingTariff",
}

export type UpdateElements = {
  hardwareType: string;
  simType?: string; // only for configs
  id: string;
  label: string;
  tags: string[];
  description: string;
};

export enum UpdateType {
  firmware = "firmware",
  config = "config",
}

export enum FsmType {
  cancel = "cancel",
  reset = "reset",
}

export type SchedulePopupData = {
  scheduledUpdateID: string | undefined;
  deviceIds: string[] | undefined;
  updateType: UpdateType;
  simTypes: Set<string | undefined>;
  hardwareTypes: Set<string>;
  deviceFirmwareID: string | number | undefined;
  allowedFrom: string | undefined;
  allowedTo: string | undefined;
  ignitionOn: boolean;
  ignitionOff: boolean;
};